import { SubjectListItem } from '@/project-subject/subject-config/subject-config'

export const ShanXi: SubjectListItem = {
  id: 'shan_xi',
  debug_subject_name: '陕西神信版',
  domains: ['sxsx.mingting.cn'],
  logo_login_page: require('./_images/logo-login-page.png'),
  logo_dashboard_header: require('./_images/logo-dashboard-header.png'),
  logo_dashboard_header_dark: require('./_images/logo-dashboard-header-dark.png'),
  phone_pre_sale: '150-9131-0199',
  phone_after_sale: '0912-8015566',
  mail: '1775876871@qq.com',
  sign_app_id: 'shenxin',
  sign_key: 'SOyy1KTQ0op56.X'
}
